import type { Theme } from '../../types/theme';

export const claudeTheme: Theme = {
  id: 'claude',
  name: 'Claude',
  description: 'Warm editorial design with cream canvas and coral accents. Literary, humanist, and inviting.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/claude/DESIGN.md',
  visualKeywords: ['warm', 'editorial', 'humanist', 'cream canvas', 'coral CTA', 'serif headlines'],
  colors: {
    background: '#faf9f5',
    surface: '#efe9de',
    surfaceElevated: '#f5f0e8',
    surfaceDark: '#181715',
    textPrimary: '#141413',
    textSecondary: '#3d3d3a',
    textMuted: '#6c6a64',
    border: '#e6dfd8',
    primary: '#cc785c',
    primaryHover: '#a9583e',
    primaryActive: '#a9583e',
    accent: '#5db8a6',
    onPrimary: '#ffffff',
    success: '#5db872',
    warning: '#d4a017',
    error: '#c64545',
  },
  typography: {
    headingFont: '"Tiempos Headline", Georgia, serif',
    bodyFont: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    monoFont: '"JetBrains Mono", monospace',
    headingWeight: '400',
    bodyWeight: '400',
    letterSpacingHeading: '-0.5px',
  },
  radius: {
    button: '8px',
    card: '12px',
    panel: '16px',
    badge: '9999px',
    input: '8px',
  },
  shadow: {
    card: '0 4px 12px rgba(0, 0, 0, 0.08)',
    elevated: '0 8px 24px rgba(0, 0, 0, 0.12)',
    button: 'none',
    none: 'none',
  },
  layout: {
    maxWidth: '1200px',
    sectionSpacing: '96px',
    cardPadding: '32px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'warm, literary, thoughtful',
    productFit: ['AI assistant', 'Knowledge base', 'Content platform', 'Writing tool'],
    bestFor: ['Trust-building products', 'Content-heavy SaaS', 'Personal AI assistants'],
    notGoodFor: ['High-frequency trading', 'Cybersecurity consoles', 'Gaming products'],
  },
};
